export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/takahiro-sakamoto-64153c99009a1353ec05ccd3db08a1e7.jpg";